import React, { useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from '../../../app/store';
import { initializeRegistration, updateRegistration } from '../../../services/RegistrationService/registrationSlice';
import { useAppSelector } from '../../../app/store';
import { CardContent, Stack, Box, Typography } from '@mui/material';
import { PersonOutline, HomeOutlined } from '@mui/icons-material';
import { PageContainer, PageCard, SectionHeader, SectionPaper } from '../../common/components';
import GoBackButton from '../../common/components/styled-ui-elements/GoBackButton';
import { FirstNameEdit, MiddleNameEdit, LastNameEdit, GenderEdit, DateOfBirthEdit, RaceEdit, MaritalStatusEdit, PrimaryPhoneEdit, EmailEdit, AlternatePhoneEdit } from '../components/fieldEditors';
import { AddressGrid } from '../components/grids';
import { SaveRegistrationButton } from '../components/commands';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}


const RegistrationCreate: React.FC = () => {
  const query = useQuery();
  const company = query.get('company') || '';
  const center = query.get('center') || '';

  const dispatch = useAppDispatch();
  const registration = useAppSelector((state) => state.registration.currentRegistration);



  useEffect(() => {
    dispatch(initializeRegistration());
    // Set company and center in the registration object if present
    if (company || center) {
      dispatch(updateRegistration({
        identifiers: {
          ...(company ? { company } : {}),
          ...(center ? { center } : {}),
        },
      }));
    }
  }, [dispatch, company, center]);

  return (
    <PageContainer>
      <Box display="flex" justifyContent="center">
        <PageCard>
          {/* Professional Header */}
          <Box
            sx={{
              backgroundColor: '#ffffff',
              borderBottom: '2px solid #3b82f6',
              p: 2.5,
              position: 'relative',
            }}
          >
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Box>
                <Typography variant="h5" component="h1" fontWeight={600} color="#1e293b" sx={{ mb: 0.5 }}>
                  Patient Registration
                </Typography>
                <Typography variant="body2" color="#64748b" sx={{ fontSize: '0.9rem' }}>
                  Complete all required fields to register a new patient
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={2}>
                <SaveRegistrationButton mode="create" />
                <GoBackButton />
              </Box>
            </Box>
          </Box>
          <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
            <form autoComplete="off">
              <Stack spacing={2.5}>
                {/* Patient Information Section */}
                <Box>
                  <SectionHeader icon={<PersonOutline sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />} title="Patient Information" />
                  <SectionPaper>
                    {/* Name Fields */}
                    <Stack direction="row" gap={2} sx={{ mb: 2 }}>
                      <FirstNameEdit />
                      <MiddleNameEdit />
                      <LastNameEdit />
                    </Stack>
                    {/* Demographics Fields */}
                    <Stack direction="row" gap={2} sx={{ mb: 2 }}>
                      <DateOfBirthEdit />
                      <GenderEdit />
                      <RaceEdit />
                      <MaritalStatusEdit />
                    </Stack>
                    {/* Contact Information Fields */}
                    <Stack direction="row" gap={2}>
                      <PrimaryPhoneEdit />
                      <EmailEdit />
                      <AlternatePhoneEdit />
                    </Stack>
                  </SectionPaper>
                </Box>
                {/* Address Information Section */}
                <Box>
                  <SectionHeader icon={<HomeOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />} title="Address Information" />
                  <SectionPaper>
                    <AddressGrid />
                  </SectionPaper>
                </Box>
              </Stack>
            </form>
          </CardContent>
        </PageCard>
      </Box>
    </PageContainer>
  );
};

export default RegistrationCreate;
